import MailOutlineIcon from "@mui/icons-material/Mail";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const CONTACT_EMAIL = "vorstand@sgi-ev.de";

export default function ContactMailLink({ align }) {
  return (
    <Box textAlign={align || "left"}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Schreiben Sie uns einfach eine E-Mail, wir melden uns so schnell wie
        möglich bei Ihnen zurück.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<MailOutlineIcon />}
        href={`mailto:${CONTACT_EMAIL}`}
      >
        {CONTACT_EMAIL}
      </Button>
    </Box>
  );
}
